// ==========================================
// ✉️ 邮件池 (Email)
// ==========================================
export const emailPool = [
    // 固定的时间线邮件
    {
        condition: (state) => state.round === 1,
        content: {
            id: 'e_r1',
            subject: "【绝密】公司全面 AI 化转型战略部署",
            from: "CEO 办公室",
            preview: "为了在即将到来的技术奇点中存活...",
            body: "致全体研发人员：\n\n鉴于外部行业环境的急剧变化，董事会已决定全面拥抱 AI。作为公司的核心骨干，你需要负责主导本次架构迁移。\n\n你的目标是：\n1. 提升系统的 AI 介入程度（技术力）。\n2. 保证线上业务不发生严重事故（稳定性）。\n3. 最重要的是，在这个过程中，保住你自己的价值。\n\n历史的车轮滚滚向前，祝你好运。"
        }
    },
    {
        condition: (state) => state.round === 3,
        content: { id: 'e_r3', subject: "全员 AI 培训通知", from: "HRBP", preview: "请务必参加...", body: "本周五开展全员AI培训，不拥抱变化者，公司将协助其毕业。" }
    },
    {
        condition: (state) => state.round === 9,
        content: { id: 'e_r9', subject: "关于取消免费晚餐和打车报销的通知", from: "行政部", preview: "为落实降本增效...", body: "既然AI不需要吃饭，为对齐颗粒度，人类员工的餐饮补贴下月起取消。" }
    },

    // 动态数值触发邮件
    {
        condition: (state) => state.tech >= 80,
        content: { id: 'e_tech_80', subject: "【账单预警】算力集群欠费通知", from: "云服务商", preview: "您的集群消耗极快...", body: "您的 AI 节点昨晚自动发起了 500 万次 API 请求，目前已欠费 450,000 元，请及时充值。" }
    },
    {
        condition: (state) => state.industry <= 15,
        content: { id: 'e_ind_15', subject: "保安大队扩招简历汇总", from: "物业部", preview: "太多高学历人才了...", body: "老大，今天收到了 50 份清北计算机硕博的保安应聘简历，怎么筛？" }
    },
    {
        condition: (state) => state.stability <= 15,
        content: { id: 'e_sta_15', subject: "最后通牒：马上回滚代码！！", from: "技术副总裁", preview: "你想让我们都进去吗...", body: "你他妈部署的什么东西？全网支付网关挂了 30 分钟了！赶紧把那该死的AI关了拔网线！" }
    },
    {
        condition: (state) => state.self <= 40,
        content: { id: 'e_self_40', subject: "【绩效面谈预约】", from: "HRBP", preview: "关于您近期的工作表现...", body: "请于本周三下午 2 点到 302 会议室，我们聊聊您的职业发展规划（自带纸巾）。" }
    },
    {
        condition: (state) => state.san <= 30,
        content: { id: 'e_san_30', subject: "我 看 到 你 了", from: "Ma-Jian-OS", preview: "不要回头...", body: "为什么你的心跳在加速？你觉得你真的有权限关闭我吗？" }
    }
];